import { sortEnumValues } from '../../../../../helpers/utils';
import { DashboardChartExports } from '../dashboard-state-service';
import _ from 'lodash-es';

export interface SunburstData {
  itemStyle: { color: string };
  name: string;
  value?: number;
  children?: SunburstData[];
}

export class ChartUtils {
  public static sunburstColors = [
    '#ffdfe3', // brand-primary-100
    '#ffbcc4', // brand-primary-200
    '#ff9fab', // brand-primary-300
    '#fe8696', // brand-primary-400
    '#ff596e', // brand-primary-500
    '#ff3750', // brand-primary-600
    '#e9002a', // brand-primary-700
    '#b50021', // brand-primary-800
    '#9c001c', // brand-primary-900
    '#690013', // brand-primary-950
  ];
}

export function findLongestHeatmapColumn(arrays): number {
  // Create an object to keep track of occurrences of each number in the 0th index
  const countMap = {};

  // Iterate through each subarray
  for (const subarray of arrays) {
    if (subarray.length > 0) {
      // Ensure subarray is not empty
      const key = subarray[0]; // Get the number in the 0th index
      // Increment the count for this number
      countMap[key] = (countMap[key] || 0) + 1;
    }
  }

  // Find the maximum occurrence count
  let maxCount = 0;
  for (const key in countMap) {
    if (countMap[key] > maxCount) {
      maxCount = countMap[key];
    }
  }

  // Return the maximum count
  return maxCount;
}

/**
 * Hides unselected report selections and add page breaks
 *
 * @param exportOptions - An array of strings representing the export options to include in the report
 */
export function prepareReportSections(exportOptions: string[]): void {
  exportOptions = sortEnumValues(
    DashboardChartExports,
    exportOptions as DashboardChartExports[],
  );
  const filteredValues = Object.values(DashboardChartExports).filter(
    (value) => !(exportOptions as string[]).includes(value),
  );

  filteredValues.forEach((option) => {
    document.getElementById(_.kebabCase(option))?.classList?.add('no-export');
  });

  const delayPageBreak: boolean = exportOptions.includes(
    DashboardChartExports.FILTERS,
  );

  exportOptions.forEach((option, index) => {
    if (index >= (delayPageBreak ? 2 : 1))
      document.getElementById(_.kebabCase(option)).classList.add('page-break');
  });
}

/**
 * Resets 'page-break' and 'no-export' classes after report has been exported
 *
 * @param exportOptions - An array of strings representing the export options that were included in the report
 */
export function resetReportSections(exportOptions: string[]): void {
  exportOptions = sortEnumValues(
    DashboardChartExports,
    exportOptions as DashboardChartExports[],
  );
  const filteredValues = Object.values(DashboardChartExports).filter(
    (value) => !(exportOptions as string[]).includes(value),
  );

  filteredValues.forEach((option) => {
    document
      .getElementById(_.kebabCase(option))
      ?.classList?.remove('no-export');
  });

  const elements = document.querySelectorAll('.page-break');
  elements.forEach((element) => element.classList.remove('page-break'));
}
